import { mapState } from "vuex";
import {
  addHours,
  differenceInHours,
  isAfter,
  isSameDay,
  format,
  isBefore,
  isSameMinute,
  addMinutes,
  differenceInMinutes,
} from "date-fns";
import { parseISO } from "date-fns/fp";
import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

export default {
  data() {
    return {
      e1: 1,
      snackTimeout: "5000",
      show_full_cal: false,
      durations: [15, 30, 45, 60],
      locations: [
        { value: "office", option: "Advisor's Office" },
        { value: "phone", option: "Phone" },
        { value: "zoom", option: "Zoom" },
      ],
      advisors: [],
      defaultAdvisors: [],
      currentTerm: null,
      selectedDuration: null,
      selectedAdvisor: null,
      selectedLocation: null,
      weekday: [1, 2, 3, 4, 5, 6, 0],
      focus: "",
      type: "week",
      today: null,
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      dailyTimeStart: 8,
      dailyTimeEnd: 18,
      advisorAvailability: [],
      advisorPreference: {},
      advisorCalendar: [],
      events: [],
      studentComment: null,
      studentContact: null,
      studentDetails: {},
      confirmBtnState: false,
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
      searchAdvisorPin: null,
    };
  },
  computed: {
    ...mapState({
      statusfromStore: (state) => state.status,
    }),
    statusSnack: {
      get() {
        return this.statusfromStore;
      },
      set(newName) {
        return newName;
      },
    },
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const endMonth = this.monthFormatter(end);
      const suffixMonth = startMonth === endMonth ? "" : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? startYear : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case "month":
          return `${startMonth} ${startYear}`;
        case "week":
        case "4day":
          return `${startMonth} ${startDay} - ${suffixMonth} ${endDay}, ${suffixYear}`;
        case "day":
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return "";
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long",
      });
    },
  },
  watch: {
    selectedAdvisor: async function (val) {
      await this.getAdvisorPreference();
      await this.getAdvisorAvailability();
    },
    statusSnack: function (val) {
      this.statusSnack = val;
    },
  },
  created() {
    this.getSemesters();
  },
  mounted() {
    this.$refs.calendar.checkChange();
    this.getAdvisorsList();
  },
  methods: {
    resetStatusSnack() {
      this.$store.commit("status/setStatus", {
        snack: false,
        snackColor: "",
        snackText: "",
      });
    },

    async getStudentDetails() {
      await axios
        .get("/api/v1/studentdetailslookup/" + this.$attrs.uin)
        .then((response) => {
          this.studentDetails = response.data;
        })
        .catch((error) => {});
    },
    async getAdvisorsList() {
      await axios
        .get("/api/v1/advisors/")
        .then((response) => {
          this.defaultAdvisors = response.data.data;
        })
        .catch((error) => {});
    },
    async getAdvisors(term) {
      await this.getStudentDetails();
      await axios
        .get(
          "/api/v1/advisorlist/" + this.$attrs.uin + "/" + term
        )
        .then((response) => {
          // this.advisors = response.data;
          this.advisors = [
            ...new Set([...response.data, ...this.defaultAdvisors]),
          ];

          /* FOR SUMMER ORIENTATIONS ONLY
                            if ((this.studentDetails.act_composite == null || this.studentDetails.act_composite <= 18) && (this.studentDetails.sat_total == null || this.studentDetails.sat_total <= 970) && this.studentDetails.total_credits < 30) {
                              if (this.studentDetails.recruited_athlete != "YES" && this.studentDetails.stars_deferred != "YES") {
                                this.advisors = [
                                  { advsr_email_addr:"cbell32@uis.edu", advsr_pers_fname:"Carleen", advsr_pers_lname:"Benoit", advsr_uin:"671686235" }
                                ]
                              }
                            }
                    else if (this.studentDetails.is_honors_student == false) {
              */

          if (this.studentDetails.is_honors_student == false) {
            if (
              this.studentDetails.recruited_athlete != "YES" &&
              this.studentDetails.total_credits < 30
            ) {
              if (
                this.advisors.some(
                  (advisor) =>
                    advisor.advsr_email_addr.toLowerCase() != "aegiz1@uis.edu"
                )
              ) {
                this.advisors.push({
                  advsr_email_addr: "aegiz1@uis.edu",
                  advsr_pers_fname: "Andy",
                  advsr_pers_lname: "Egizi",
                  advsr_uin: "666175117",
                });
              }
              if (
                this.advisors.some(
                  (advisor) =>
                    advisor.advsr_email_addr.toLowerCase() != "oraya3@uis.edu"
                )
              ) {
                this.advisors.push({
                  advsr_email_addr: "oraya3@uis.edu",
                  advsr_pers_fname: "Olivia",
                  advsr_pers_lname: "Raya",
                  advsr_uin: "668948536",
                });
              }
            }
          } else if (this.studentDetails.recruited_athlete != "YES") {
            if (
              this.studentDetails.is_honors_student == false &&
              this.studentDetails.total_credits < 30
            ) {
              if (
                this.advisors.some(
                  (advisor) =>
                    advisor.advsr_email_addr.toLowerCase() != "aegiz1@uis.edu"
                )
              ) {
                this.advisors.push({
                  advsr_email_addr: "aegiz1@uis.edu",
                  advsr_pers_fname: "Andy",
                  advsr_pers_lname: "Egizi",
                  advsr_uin: "666175117",
                });
              }
              if (
                this.advisors.some(
                  (advisor) =>
                    advisor.advsr_email_addr.toLowerCase() != "oraya3@uis.edu"
                )
              ) {
                this.advisors.push({
                  advsr_email_addr: "oraya3@uis.edu",
                  advsr_pers_fname: "Olivia",
                  advsr_pers_lname: "Raya",
                  advsr_uin: "668948536",
                });
              }
            }
          }
          this.advisors = Array.from(
            new Set(this.advisors.map((a) => a.advsr_uin))
          ).map((advsr_uin) => {
            return this.advisors.find((a) => a.advsr_uin === advsr_uin);
          });
        })
        .catch((error) => {});
    },

    async getAdvisor() {
      if (this.searchAdvisorPin == null) {
        return;
      }
      await axios
        .get(
          "/api/v1/externalscheduler/advisor/" +
          this.searchAdvisorPin +
          "/" +
          this.currentTerm
        )
        .then((response) => {
          if (response.data) {
            console.warn(response.data)
            this.selectedAdvisor = response.data;
          }
        })
        .catch((error) => {
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "error",
            snackText: error.response.data.message,
          });
        });
    },

    async displayCalendar() {
      // is duration selected
      if (!this.selectedDuration) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Select appointment duration",
        });
        return;
      }
      // is advisor selected
      if (!this.selectedAdvisor) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Select a staff member",
        });
        return;
      }

      await this.updateRange({ start: this.start, end: this.end });
      this.e1 = 2;
    },
    displayConfirmationPage() {
      // is location selected
      if (!this.selectedLocation) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Select appointment location",
        });
        return;
      }

      this.e1 = 4;
    },

    displayFormatpage() {
      if (Object.keys(this.selectedEvent).length == 0) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Select time slot to proceed",
        });
        return;
      }
      this.e1 = 3;
    },
    getWeekDates(startDate) {
      let curr = new Date(startDate);
      let week = [];
      let days = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ];
      for (let i = 1; i < 8; i++) {
        let first = curr.getDate() - curr.getDay() + i;
        let day = format(new Date(curr.setDate(first)), "yyyy-MM-dd");
        week[days[i-1]] = day;
      }
      // console.warn(week);
      return week;
    },
    addEventToList(start, end, name, color) {
      this.events.push({
        start: start,
        end: end,
        name: name,
        color: color,
      });
    },
    getCalendarHead(
      outlookCalendar,
      advisorStart,
      advisorStop,
      prevStop = null,
      lastDbAvailIndex
    ) {
      outlookCalendar = outlookCalendar.filter((event) => {
        if (prevStop == null) {
          return this.isDateSameOrBefore(event.end_date, advisorStop);
        } else {
          return (
            this.isDateSameOrAfter(event.start_date, prevStop) &&
            this.isDateSameOrBefore(event.end_date, advisorStop)
          );
        }
      });
      var eventsBeforeAdvisorAvail = outlookCalendar.filter((event) =>
        this.isDateSameOrBefore(event.start_date, advisorStart)
      );
      eventsBeforeAdvisorAvail = eventsBeforeAdvisorAvail.sort(function (a, b) {
        return Math.abs(new Date(a.end_date) - new Date(b.end_date));
      });
      var head =
        eventsBeforeAdvisorAvail.length > 0
          ? eventsBeforeAdvisorAvail[eventsBeforeAdvisorAvail.length - 1][
              "end_date"
            ]
          : advisorStart;
      return isAfter(new Date(head), new Date(advisorStart)) &&
        lastDbAvailIndex == false
        ? head
        : advisorStart;
    },

    getLocalizedTime(date_time){
      var utcDate = zonedTimeToUtc(date_time, 'America/Chicago')
      var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var localizedTime = format(utcToZonedTime(utcDate, timeZone), "yyyy-MM-dd HH:mm")
      return localizedTime
    },

    getCentralTime(date_time){
      var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var utcDate = zonedTimeToUtc(date_time,  timeZone)
      var localizedTime = format(utcToZonedTime(utcDate, 'America/Chicago'), "yyyy-MM-dd HH:mm")
      return localizedTime
    },

    getFormattedStartEndDates(date, from, start, duration) {
      var startDateTime = format(
        addMinutes(new Date(parseISO(`${date} ${from}`)), start),
        "yyyy-MM-dd HH:mm"
      );
      var end = parseInt(start) + parseInt(duration);
      var endDateTime = format(
        addMinutes(new Date(parseISO(`${date} ${from}`)), end),
        "yyyy-MM-dd HH:mm"
      );
      return [startDateTime, endDateTime]
    },

    slotAvailabilityBeforeAfter(index, duration, date, from) {
      var beforeStart = parseInt(duration) * (index-1);
      var beforeStartDateTime = format(
        addMinutes(new Date(parseISO(`${date} ${from}`)), beforeStart),
        "yyyy-MM-dd HH:mm"
      );
      var beforeEnd = parseInt(beforeStart) + parseInt(duration);
      var beforeEndDateTime = format(
        addMinutes(new Date(parseISO(`${date} ${from}`)), beforeEnd),
        "yyyy-MM-dd HH:mm"
      );
      
      var afterStart = parseInt(duration) * (index+1);
      var afterStartDateTime = format(
        addMinutes(new Date(parseISO(`${date} ${from}`)), afterStart),
        "yyyy-MM-dd HH:mm"
      );
      var afterEnd = parseInt(afterStart) + parseInt(duration);
      var afterEndDateTime = format(
        addMinutes(new Date(parseISO(`${date} ${from}`)), afterEnd),
        "yyyy-MM-dd HH:mm"
      );
      return [beforeStartDateTime, beforeEndDateTime, afterStartDateTime, afterEndDateTime]
    },

    startTimeOverlap(outlookCalendar, start, end, buffer) {
      if (buffer > 0) {
        var isNotAvailable = outlookCalendar.some(
        (event) =>
          this.isDateInBetween(
            new Date(parseISO(start)),
            new Date(parseISO(event.start_date)),
            new Date(parseISO(event.end_date))
          ) ||
          isSameMinute(
            new Date(parseISO(start)),
            new Date(parseISO(event.start_date))
          ) ||
          isSameMinute(
            new Date(parseISO(start)),
            new Date(parseISO(event.end_date))
          ) ||
          this.isDateInBetween(
            new Date(parseISO(event.end_date)),
            new Date(parseISO(start)),
            new Date(parseISO(end))
          )
        );
      } else {
        var isNotAvailable = outlookCalendar.some(
        (event) =>
          this.isDateInBetween(
            new Date(parseISO(start)),
            new Date(parseISO(event.start_date)),
            new Date(parseISO(event.end_date))
          ) ||
          isSameMinute(
            new Date(parseISO(start)),
            new Date(parseISO(event.start_date))
          ) ||
          this.isDateInBetween(
            new Date(parseISO(event.end_date)),
            new Date(parseISO(start)),
            new Date(parseISO(end))
          )
        );
      }
      return isNotAvailable
    },

    endTimeOverlap(outlookCalendar, start, end, buffer) {
      if (buffer > 0) {
        var isNotAvailable = outlookCalendar.some(
        (event) =>
          this.isDateInBetween(
            new Date(parseISO(end)),
            new Date(parseISO(event.start_date)),
            new Date(parseISO(event.end_date))
          ) ||
          isSameMinute(
            new Date(parseISO(end)),
            new Date(parseISO(event.end_date))
          ) ||
          this.isDateInBetween(
            new Date(parseISO(event.start_date)),
            new Date(parseISO(start)),
            new Date(parseISO(end))
          ) ||
          this.isDateInBetween(
            new Date(parseISO(event.end_date)),
            new Date(parseISO(start)),
            new Date(parseISO(end))
          ) ||
          isSameMinute(
            new Date(parseISO(start)),
            new Date(parseISO(event.end_date))
          )
        );
      } else {
        var isNotAvailable = outlookCalendar.some(
        (event) =>
          this.isDateInBetween(
            new Date(parseISO(end)),
            new Date(parseISO(event.start_date)),
            new Date(parseISO(event.end_date))
          ) ||
          isSameMinute(
            new Date(parseISO(end)),
            new Date(parseISO(event.end_date))
          ) ||
          this.isDateInBetween(
            new Date(parseISO(event.start_date)),
            new Date(parseISO(start)),
            new Date(parseISO(end))
          ) ||
          this.isDateInBetween(
            new Date(parseISO(event.end_date)),
            new Date(parseISO(start)),
            new Date(parseISO(end))
          )
        );
      }
      
      return isNotAvailable
    },

    slotNotAvailable(outlookCalendar, start, end) {
      var isNotAvailable = outlookCalendar.filter(
        (event) =>
          this.isDateInBetween(
            new Date(parseISO(start)),
            new Date(parseISO(event.start_date)),
            new Date(parseISO(event.end_date))
          ) ||
          this.isDateInBetween(
            new Date(parseISO(end)),
            new Date(parseISO(event.start_date)),
            new Date(parseISO(event.end_date))
          ) ||
          isSameMinute(
            new Date(parseISO(start)),
            new Date(parseISO(event.start_date))
          ) ||
          isSameMinute(
            new Date(parseISO(end)),
            new Date(parseISO(event.end_date))
          )
      );
      return isNotAvailable
    },

    async generateEventList() {
      /**
       * this method generates the appointment blocks and is rendered on the vue calendar
       * Appoinments are the same as events
       * */
      this.events = [];
      // Get an array of dates in the current week starting from current calendar start date
      var dates = this.getWeekDates(this.start.date);
      // For each of the dates in the current week, get advisor DB availability and also calendar events
      Object.keys(dates).forEach((day) => {
        var date = dates[day];
        // only create appointment timeslots for dates greater than or equal today
        var formatted_date = format(new Date(), "yyyy-MM-dd")
        if (
          this.isDateSameOrAfter(
            format(parseISO(`${date}`), "yyyy-MM-dd"),
            formatted_date
          )
        ) {
          //get advisor DB availability at the current day/date
          var dbAvailabilityByDay = this.advisorAvailability[day];
          //get advisor calendar at the current date // might have to sort calendar dates
          var outlookCalendar = this.advisorCalendar.filter(
            (event) =>
              event.start_date.includes(date) ||
              this.isDateInBetween(date, event.start_date, event.end_date)
          );

          if (outlookCalendar) {
            var hasAnEventAllDay = outlookCalendar.some(
              (event) =>
                differenceInHours(
                  new Date(event.end_date),
                  new Date(event.start_date)
                ) >= 23
            );
          }
          
          if (dbAvailabilityByDay != undefined) {
            // for each db available dates, generate appointment timeslots
            dbAvailabilityByDay.forEach((time, index) => {
              var from = time["from"];
              var to = time["to"];
              /**
               * check if variable 'date' is today and now() is >= dbAvailiability[index]['from]
               * if now() is geater than or equal to db availability start time, then we add schedule_buffer time to the start time
               *  So that students can only select future times on the calendar
               *  Also check that the new start time after add scheduler buffer if less or equal to db availability end_time/to
               *
               *  TO DO
               *  if from->minutes is less than 30 minutes, round to the nearest 30 minutes, equivalent to adding 30 minutes to "from"
               *  if from->minutes is greater than 30minutes but less than 59 minutes, round to the nearest 60 minutes, equivalent to adding an hour to "from"
               */

              if (!this.isDateSameOrBefore(new Date(parseISO(`${date} ${to}`)), addHours(new Date(), this.advisorPreference.schedule_buffer))) {


              if (
                isSameDay(parseISO(date), new Date()) &&
                (this.isDateSameOrAfter(
                  new Date(),
                  new Date(parseISO(`${date} ${from}`))
                ) ||
                  this.isDateSameOrBefore(
                    new Date(parseISO(`${date} ${from}`)),
                    addHours(new Date(), this.advisorPreference.schedule_buffer)
                  ))
              ) {
                let coeff = 1000 * 60 * 15;
                let date_cst = new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })
                let date = new Date(date_cst)
                let rounded = new Date(Math.round(date.getTime() / coeff) * coeff)
                from = format(
                  addHours(rounded, this.advisorPreference.schedule_buffer),
                  "HH:mm:ss"
                );
              }
              if (
                from != null &&
                to != null &&
                isBefore(
                  new Date(parseISO(`${date} ${from}`)),
                  new Date(parseISO(`${date} ${to}`))
                ) &&
                isBefore(
                  addMinutes(new Date(parseISO(`${date} ${from}`)), (this.selectedDuration -1)),
                  new Date(parseISO(`${date} ${to}`))
                ) &&
                hasAnEventAllDay == false
              ) {
                //compute the number of slot between from and to
                var duration = differenceInMinutes(
                  new Date(parseISO(`${date} ${to}`)),
                  new Date(parseISO(`${date} ${from}`))
                );

                // Add buffer time between event slots for advisor as per preferences
                var bufferBetweenSlots = this.advisorPreference.schedule_in_between_buffer;

                // comput the number of slots based on the duration
                duration = duration < 0 ? 0 : duration;
               
                var spots = Math.floor(duration / this.selectedDuration);
                var calculatedBuffer = 0;

                // Assign slot to time bass

                for (let index = 0; index < spots; index++) {
                  var _start = (parseInt(this.selectedDuration) * index) + bufferBetweenSlots;
                  var calculatedDates = this.getFormattedStartEndDates(date, from, _start, this.selectedDuration);
                  if (this.startTimeOverlap(outlookCalendar, calculatedDates[0], calculatedDates[1], bufferBetweenSlots) == false){

                    if(index == 0){
                      var start = parseInt(this.selectedDuration) * index;
                    }else{
                      
                      var calculatedSlots  = this.slotAvailabilityBeforeAfter(index, this.selectedDuration, date, from);
                      var start = parseInt(this.selectedDuration) * index;
                      var reservedEvent  = this.slotNotAvailable(outlookCalendar, calculatedSlots[0], calculatedSlots[1]) 
                      var timeDifference = 0;
                      if ((reservedEvent.length > 0) && (bufferBetweenSlots > 0)){
                        timeDifference = differenceInMinutes(
                          new Date(this.getCentralTime(reservedEvent[0].end_date)),
                          new Date(this.getCentralTime(calculatedSlots[1] + ':00'))
                        );  
                        timeDifference = timeDifference > 0 ? timeDifference : 0
                        calculatedBuffer = bufferBetweenSlots + timeDifference;
                      }
                      start = start + calculatedBuffer;
                      var calculatedDates = this.getFormattedStartEndDates(date, from, (start + bufferBetweenSlots), this.selectedDuration);
                    }
                    if (this.endTimeOverlap(outlookCalendar, calculatedDates[0], calculatedDates[1], bufferBetweenSlots) == true){
                      continue;
                    }
                    var end = parseInt(start) + parseInt(this.selectedDuration);
                    if (end > duration){
                      break;
                    }
                    var startDateTime = format(
                      addMinutes(new Date(parseISO(`${date} ${from}`)), start),
                      "yyyy-MM-dd HH:mm"
                    );
                    var startTime = this.getLocalizedTime(startDateTime)
    
                    var endDateTime = format(
                      addMinutes(new Date(parseISO(`${date} ${from}`)), end),
                      "yyyy-MM-dd HH:mm"
                    );
                    var endTime = this.getLocalizedTime(endDateTime)
                    
                    // Check if the time is available on outlookcalender of the advisor
                    
                    var isNotAvailable = outlookCalendar.some(
                      (event) =>
                        this.isDateInBetween(
                          new Date(parseISO(startTime)),
                          new Date(parseISO(this.getLocalizedTime(event.start_date))),
                          new Date(parseISO(this.getLocalizedTime(event.end_date)))
                        ) ||
                        this.isDateInBetween(
                          new Date(parseISO(endTime)),
                          new Date(parseISO(this.getLocalizedTime(event.start_date))),
                          new Date(parseISO(this.getLocalizedTime(event.end_date)))
                        ) ||
                        isSameMinute(
                          new Date(parseISO(startTime)),
                          new Date(parseISO(this.getLocalizedTime(event.start_date)))
                        ) ||
                        isSameMinute(
                          new Date(parseISO(endTime)),
                          new Date(parseISO(this.getLocalizedTime(event.end_date)))
                        )
                    );
                    // Add to view basse on availability on the advisor's calendar
                    if (isNotAvailable == false || outlookCalendar.length == 0) {
                      this.addEventToList(
                        startTime,
                        endTime,
                        "Available",
                        this.getColorByDate(startTime)
                      );
                    }
                  }else{
                    continue;
                  }
                }
              }
            } else {
              console.warn("TODAY ENDED ALREADY")
          }
            });
          }
        }
      });
    },

    async getAdvisorAvailability() {
      let advisor_uin = this.selectedAdvisor.advsr_uin;
      await axios
        .get("/api/v1/advisoravailability/" + advisor_uin)
        .then((response) => {
          if (response.data) {
            this.advisorAvailability = response.data;
          }
        })
        .catch((error) => {});
    },
    async getAdvisorPreference() {
      let advisor_uin = this.selectedAdvisor.advsr_uin;
      await axios
        .get("/api/v1/advisorpreference/" + advisor_uin)
        .then((response) => {
          if (response.data) {
            this.advisorPreference = response.data;
            this.durations = JSON.parse(
              response.data["appointment_lengths"]
            ).sort();
            this.locations = this.formatLocation(
              JSON.parse(response.data["appointment_formats"]).sort()
            );
          }
        })
        .catch((error) => {});
    },
    async getAdvisorCalendar() {
      let advisor_netid = this.selectedAdvisor.advsr_email_addr
        .split("@")[0]
        .toLowerCase();
      await axios
        .post("/api/v1/advisorsearchcalendar/", {
          start: `${this.start.date} 00:00:00`,
          end: `${this.end.date} 23:00:00`,
          advisorNetId: advisor_netid,
        })
        .then((response) => {
          this.advisorCalendar = response.data;
        })
        .catch((error) => {});
    },
    async getSemesters() {
      await axios
        .get("/api/v1/semesterlookup")
        .then((response) => {
          //this.currentTerm = response.data.additional_semester;
          this.currentTerm = response.data.current_semester;
          if (this.$attrs.uin != undefined){
            this.getAdvisors(this.currentTerm);
          }
        })
        .catch((error) => {});
    },

    async confirmAppointment() {
      if (!this.studentComment) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Enter advising comment",
        });
        return;
      }
      if (!this.studentContact) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Enter contact information",
        });
        return;
      }
      this.confirmBtnState = true; // disable confirm button
      this.$store.commit("status/setStatus", {
        snack: true,
        snackColor: "info",
        snackText: "Please wait while we confirm your appointment",
      });
      
      let advisor_netid = this.selectedAdvisor.advsr_email_addr
        .split("@")[0]
        .toLowerCase();
      let student_netid = this.$attrs.email.split("@")[0].toLowerCase();
      await axios
        .post("/api/v1/addappointmentcalendar/", {
          start: `${this.getCentralTime(this.selectedEvent.start)}:00`,
          end: `${this.getCentralTime(this.selectedEvent.end)}:00`,
          subject: `Advising - ${this.studentDetails.firstname} ${this.studentDetails.lastname}`,
          studentComment: this.studentComment,
          studentContact: this.studentContact,
          format: this.selectedLocation,
          studentName: `${this.studentDetails.firstname} ${this.studentDetails.lastname}`,
          studentMajor: this.studentDetails.major,
          advisingDetails: this.advisorPreference.scheduling_information,
          studentUin: this.$attrs.uin,
          advisorNetId: advisor_netid,
          studentNetId: student_netid,
        })
        .then((response) => {
          //this.confirmBtnState = false;
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "success",
            snackText: response.data.original.message,
          });
          this.snackTimeout = "10000";
          setTimeout(function () {
            window.location.href = "/";
          }, 5000);
        })
        .catch((error) => {
          this.confirmBtnState = false;
          if (
            error.response.data &&
            error.response.data.double_booking == true
          ) {
            var msg = error.response.data.message;
          } else {
            var msg = "something went wrong";
          }
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "error",
            snackText: msg,
          });
        });
    },

    async confirmExternalAppointment() {
      if (!this.studentComment) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Enter advising comment",
        });
        return;
      }
      if (!this.studentContact) {
        this.$store.commit("status/setStatus", {
          snack: true,
          snackColor: "error",
          snackText: "Enter contact information",
        });
        return;
      }
      this.confirmBtnState = true; // disable confirm button
      this.$store.commit("status/setStatus", {
        snack: true,
        snackColor: "info",
        snackText: "Please wait while we confirm your appointment",
      });
      let advisor_netid = this.selectedAdvisor.advsr_email_addr
        .split("@")[0]
        .toLowerCase();
      await axios
        .post(
          "/api/v1/externalscheduler/addappointmentcalendar/",
          {
            start: `${this.getCentralTime(this.selectedEvent.start)}:00`,
            end: `${this.getCentralTime(this.selectedEvent.end)}:00`,
            subject: `Advising - ${this.$attrs.user.name}`,
            studentComment: this.studentComment,
            studentContact: this.studentContact,
            format: this.selectedLocation,
            studentName: `${this.$attrs.user.name}`,
            studentMajor: "Not Specified",
            advisingDetails: this.advisorPreference.scheduling_information,
            studentUin: "Not Specified",
            advisorNetId: advisor_netid,
            studentNetId: null,
            studentEmail: this.$attrs.user.email,
            googleObject: this.$attrs.user,
          }
        )
        .then((response) => {
          //this.confirmBtnState = false;
          this.snackTimeout = "10000";
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "success",
            snackText:
              "A confirmation email has been sent to your Google account",
          });
          setTimeout(function () {
            window.location.href = "/externaladvisee";
          }, 5000);
        })
        .catch((error) => {
          this.confirmBtnState = false;
          if (
            error.response.data &&
            error.response.data.double_booking == true
          ) {
            var msg = error.response.data.message;
          } else {
            var msg = "something went wrong";
          }
          this.$store.commit("status/setStatus", {
            snack: true,
            snackColor: "error",
            snackText: msg,
          });
        });
    },

    formatLocation(result) {
      var formated_location = [];
      for (var i = 0; i < result.length; i++) {
        if (result[i] == "zoom")
          formated_location.push({ value: result[i], option: "Zoom" });
        else if (result[i] == "phone")
          formated_location.push({ value: result[i], option: "Phone" });
        else if (result[i] == "office")
          formated_location.push({ value: result[i], option: "Advisor's Office" });
      }
      return formated_location;
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      this.getLocationforSelectedDay(event.start);
      //console.warn(nativeEvent, event);
      const open = () => {
        if (event.name == "Available") {
          this.events.forEach((element) => {
            if (element.start == event.start && element.end == event.end) {
              this.selectedEvent = event;
              element.color = "green";
            } else {
              if (element.color != "red") {
                element.color = this.getColorByDate(element.start);
              }
            }
          });
          this.selectedElement = nativeEvent.target;
          setTimeout(() => (this.selectedOpen = true), 10);
        }
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    selectedTime(event) {
      // get the selected duration and add to the event time

      //console.warn(event);
      var start = event.date + " " + event.time;
      var newDate = new Date(
        new Date(parseISO(start)).getTime() +
          parseInt(this.selectedDuration) * 60000
      );
      var end = this.formatDate(newDate, true);
      // check if the result elapse into another schedule time slot
      // check if its not clashing with the backend data
      // push event to calendar
      this.events.push({
        name: "My appointment",
        start: start,
        end: end,
        color: "green",
      });

      // send the created event parameters to the backend and add to advisors calendar
    },
    async updateRange({ start, end }) {
      this.start = start;
      this.end = end;
      if (Object.keys(this.advisorAvailability).length > 0) {
        await this.getAdvisorCalendar();
        await this.generateEventList();
      }
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${
            a.getMonth() + 1
          }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    generateHumanReadableTime(start, end) {
      if (start == " " || end == "" || start == null || end == null) {
        return `${format(new Date(), "eeee, MMMM do h:mm a")} - ${format(
          new Date(),
          "h:mm a (zzzz)"
        )}`;
      } else {
        return `${format(
          new Date(parseISO(start)),
          "eeee, MMMM do h:mm a"
        )} - ${format(new Date(parseISO(end)), "h:mm a (zzzz)")}`;
      }
    },
    capitalize(s) {
      if (typeof s !== "string") return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    getLocationforSelectedDay(arg) {
      var days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday", 
      ];

      const date = new Date(parseISO(this.getCentralTime(arg)));
      var dayName = days[date.getDay()];

      if (this.advisorAvailability[dayName][0].appointment_formats) {
        this.locations = this.formatLocation(
          JSON.parse(this.advisorAvailability[dayName][0].appointment_formats)
        );
      }else{
        this.locations  =[
        { value: "phone", option: "Phone" },
        { value: "zoom", option: "Zoom" },
      ]
    }

    },

    getColorByDate(arg, ar) {
      var days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ];

      const date = new Date(parseISO(this.getCentralTime(arg))); 
      var dayName = days[date.getDay()];
      return this.advisorAvailability[dayName][0]?.appointment_formats?.includes("office")? "blue": "red";
    },
  },
};
